import * as types from './mutation-types'

const mutations = {
  [types.ISCOLLECT](state, val) {
    state.isCollect = val
  }
}
export default mutations


// WEBPACK FOOTER //
// ./src/stroe/mutations.js